import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';
import { asyncPayloadCreator } from '../../../utils';

export const rejectCounteroffer = createAsyncThunk(
	'secondaryMarket/rejectCounteroffer',
	async (id: string, { rejectWithValue }) =>
		asyncPayloadCreator(id, { rejectWithValue }, SecondaryMarketService.rejectCounteroffer),
);
